import { FmsKeys } from 'Types/FmsTypes';

export const TRAVEL_COVERAGE_SUPER = 'super';
export const TRAVEL_COVERAGE_STANDARD = 'standard';
export const TRAVEL_COVERAGE_SINGLE = 'single';
export const TRAVEL_COVERAGE_FAMILY = 'family';

export const COVERAGE_LENGTH_LABEL: FmsKeys =
  'changeInsurance.travel.coverageLength.label';
export const COVERAGE_LENGTH_HINT: FmsKeys =
  'changeInsurance.travel.coverageLength.description';

export const COVERAGE_SINGLE_OR_FAMILY_LABEL: FmsKeys =
  'changeInsurance.travel.coverageSingleOrFamily.label';

export const COVERAGE_TYPE_VALIDATION_DESCRIPTION: FmsKeys =
  'changeInsurance.travel.validation.standardToSuper';
export const COVERAGE_TYPE_LABEL: FmsKeys = 'changeInsurance.coverage.label';
export const COVERAGE_TYPE_STANDARD_ALERT: FmsKeys =
  'changeInsurance.travel.alert.standardLength';

export const COVERAGE_LENGTH_TITLE_LABEL: FmsKeys =
  'changeInsurance.travel.coverageLength.title';
export const COVERAGE_LENGTH_TITLE_HINT: FmsKeys =
  'changeInsurance.travel.coverageLength.titleHint';
